/** Follow-up patch after a note is saved.
 * Contacts always refresh last_seen. Status is sent only when the note
 * carries a non-empty status, so an empty note status cannot clear the contact.
 * Deals have no last_seen; with no status there is nothing to patch.
 */
export const parentPatchFromNote = ({
  reference,
  status,
  now = new Date(),
}: {
  reference: "contacts" | "deals";
  status?: string | null;
  now?: Date;
}): { last_seen?: string; status?: string } | null => {
  const nextStatus = typeof status === "string" ? status.trim() : "";
  if (reference === "deals") {
    return nextStatus ? { status: nextStatus } : null;
  }
  return {
    last_seen: now.toISOString(),
    ...(nextStatus ? { status: nextStatus } : {}),
  };
};

export const validateNoteOrAttachmentRequired = (
  value: string | null | undefined,
  values: { attachments?: unknown[] | null },
) => {
  const hasText = typeof value === "string" && value.trim().length > 0;
  const hasAttachments =
    Array.isArray(values?.attachments) && values.attachments.length > 0;

  return hasText || hasAttachments
    ? undefined
    : "resources.notes.validation.note_or_attachment_required";
};
